import type { RouteRecordRaw } from 'vue-router';
import virtualColleagueRoutes from '@router/settings/virtual-colleague';
import DefaultBarView from '@views/Navigation/DefaultBarView.vue';
import DefaultRailView from '@views/Navigation/DefaultRailView.vue';
import SettingsView from '@views/Settings/SettingsView.vue';

const routes: RouteRecordRaw[] = [
    {
        path: '/settings',
        name: 'settings',
        components: {
            default: SettingsView,
            bar: DefaultBarView,
            rail: DefaultRailView,
        },
        children: [
            ...virtualColleagueRoutes,
        ],
    },
];

export default routes;
